import axios from "axios";
import {authHeader} from "./authHeader";

const API_URL =  process.env.REACT_APP_API_URL;



const getInspiration = (page) => {
  return axios.get(API_URL + '/api/user/inspiration', { 
    params: page,
    headers: authHeader() });
};

const addInspiration = async (formData) => {
  const response = await axios.post(API_URL + "/api/user/inspiration", formData, {  
    headers: authHeader()
  });
  return response.data;
};
const confirmInspiration = async (formData) => {
  const response = await axios.post(API_URL + "/api/user/inspiration/confirm", formData, {
    headers: authHeader()
  });
  return response;
};
// const deleteInspiration= async (id) => {
//   const response = await axios.delete(API_URL +`/api/inspiration/${id}`,{ headers:authHeader()});
//   return response;
// };


// const updateInspiration = async (serviceData) => {
//   const response = await axios.put(API_URL + `/api/inspiration/${id}`, { }, {
//     headers: authHeader()
//   });
//   return response.data; 
// };


const InspirationApi={
 getInspiration,
 addInspiration,
  confirmInspiration

}

export default InspirationApi;